<template>
  <nav class="nav" :class="{ 'nav-scrolled': hasScrolled }">
    <div class="nav-container">
      <div class="logo-container reveal-top">
        <img src="../assets/images/Bizz.png" alt="Bizz Logo" class="logo" />
      </div>

      <div class="nav-actions reveal-top delay-1">
        <a href="#waitlist" class="nav-cta">Join the Waitlist</a>
      </div>
    </div>
  </nav>
</template>

<script>
/*
export default {
  data() {
    return {
      isNavOpen: false,
      menuItems: [
        { name: "Home", link: "/", active: true },
        { name: "About", link: "/about", active: false },
        { name: "Values", link: "/values", active: false },
        { name: "Services", link: "/services", active: false },
        { name: "Careers", link: "/careers", active: false },
      ],
    };
  },
  methods: {
    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
      this.toggleAriaExpanded();
    },
    toggleAriaExpanded() {
      const csUL = document.querySelector("#cs-expanded");
      if (csUL) {
        csUL.setAttribute("aria-expanded", this.isNavOpen.toString());
      }
    },
  },
};
*/
</script>

<style scoped>
/* Container and Wrapper */
.nav {
  /* Theme Variables */
  --bg-warm-base: #f2eee0;
  --sunlight-glow: #faefca;
  --soft-gold: #f5e5b0;
  --dark-accent: #1a1a1a;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  /* Height of the navbar */
  height: 100px;
  display: flex;
  align-items: center;

  /* Glassmorphism effect */
  background: rgba(242, 238, 224, 0.85);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.nav-container {
  width: 100%;
  max-width: 1300px; /* Wider container for a high-end feel */
  margin: 0 auto;
  padding: 0 40px; /* Keeps elements from touching screen edges */
  display: flex;
  justify-content: space-between; /* This creates the "nice" Left vs Right split */
  align-items: center;
}

/* Logo Section */
.logo-container {
  display: flex;
  align-items: center;
  flex: 1; /* Allows the logo area to take its natural space */
}

.logo {
  /* Significant size increase as requested */
  height: 80px;
  width: auto;
  object-fit: contain;
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.logo:hover {
  transform: scale(1.08);
}

/* CTA Button Section */
.nav-actions {
  display: flex;
  justify-content: flex-end;
  flex: 1;
}

.nav-cta {
  background: var(--dark-accent);
  color: white;
  padding: 16px 32px; /* Thicker button for better balance */
  border-radius: 100px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: -0.01em;
  transition: all 0.3s ease;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  white-space: nowrap; /* Prevents text wrapping */
}

.nav-cta:hover {
  background: #333;
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

/* Tablet and Mobile adjustments */
@media (max-width: 768px) {
  .nav {
    height: 80px;
    padding: 0 10px;
  }

  .nav-container {
    padding: 0 20px;
  }

  .logo {
    height: 55px; /* Scaled down for mobile but still prominent */
  }

  .nav-cta {
    padding: 10px 20px;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .logo {
    height: 48px;
  }

  .nav-container {
    padding: 0 16px;
  }
}
</style>
